import { i18nMetaToJSDoc } from "@angular/compiler/src/render3/view/i18n/meta";
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, NgForm, Validators } from "@angular/forms";
import { SingleEmailValidator } from "src/app/directives/multi-email.directive";
import { ClienteInternacional } from "src/app/models/ClienteInternacional/ClienteInternacional";
import { Pais } from "src/app/models/Dte/Exportacion/Pais";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { PermissionService } from "src/app/services/permission.service";
import { TokenStorageService } from "src/app/services/token-storage.service";

@Component({
	selector: "app-international-client-entry",
	templateUrl: "./international-client-entry.component.html",
	styleUrls: ["./international-client-entry.component.scss"],
})
export class InternationalClientEntryComponent implements OnInit {
	@ViewChild("clientFormRef") private childFormRef: NgForm;
	public clientForm: FormGroup;
	private clientObj: ClienteInternacional = new ClienteInternacional();
	private emisorId: string = this.tokenStorage.getCompany();
	@Input() public clientToEdit: ClienteInternacional;
	@Input() public editMode: boolean = null;
	@Input() public detailMode: boolean = null;
	@Output() private sendCloseRequestEmitter: EventEmitter<any> = new EventEmitter<any>();
	@Output() private sendNewClientRequest: EventEmitter<any> = new EventEmitter<any>();
	@Output() private sendEditedClientRequest: EventEmitter<any> = new EventEmitter<any>();
	public paisesSource: Pais[] = [];
	public largoIdentificador: number = 15;
	constructor(private formBuilder: FormBuilder, private tokenStorage: TokenStorageService, public permissions: PermissionService, private localStorage: LocalStorageService) {}

	ngOnInit(): void {
		this.paisesSource = this.localStorage.getPaises();
		this.createForm();
		if (this.clientToEdit) {
			this.setClientDataToForm(this.clientToEdit);
		}
	}

	onSubmit() {
		if (this.clientForm.valid) {
			this.getFormData();
			if (this.clientToEdit) {
				this.sendEditedClientRequest.emit(this.clientObj);
			} else {
				this.sendNewClientRequest.emit(this.clientObj);
			}
		}
	}

	createForm() {
		this.clientForm = this.formBuilder.group({
			//identifier: ["", [Validators.required, Validators.maxLength(20)]],
			codigoInterno: ["", [Validators.required, Validators.maxLength(15)]],
			razonSocial: ["", Validators.required],
			nombreFantasia: ["", Validators.required],
			giro: ["", Validators.required],
			direccionCalle: ["", Validators.required],
			direccionNumero: ["", [Validators.required, Validators.maxLength(15)]],
			direccionLineaAdicional: [""],
			ciudad: ["", Validators.required],
			correo: ["", [Validators.required, SingleEmailValidator]],
			//telefono:["",[Validators.required,Validators.maxLength(this.largoIdentificador)]],
			direccionEstadoRegion: ["", Validators.required],
			pais: [this.paisesSource[0], Validators.required],
		});
	}

	sendCloseRequest() {
		this.sendCloseRequestEmitter.emit();
	}

	getFormData() {
		//this.clientObj.clienteInternacionalId = this.clientForm.controls.identifier.value;
		this.clientObj.razonSocial = this.clientForm.controls.razonSocial.value;
		this.clientObj.nombreFantasia = this.clientForm.controls.nombreFantasia.value;
		this.clientObj.giro = this.clientForm.controls.giro.value;
		this.clientObj.direccionCalle = this.clientForm.controls.direccionCalle.value;
		this.clientObj.direccionNumero = this.clientForm.controls.direccionNumero.value;
		this.clientObj.direccionLineaAdicional = this.clientForm.controls.direccionLineaAdicional.value;
		this.clientObj.ciudad = this.clientForm.controls.ciudad.value;
		this.clientObj.correo = this.clientForm.controls.correo.value;
		this.clientObj.direccionEstadoRegion = this.clientForm.controls.direccionEstadoRegion.value;
		//this.clientObj.telefono = this.clientForm.controls.telefono.value,
		let pais: Pais = this.clientForm.controls.pais.value;
		this.clientObj.paisId = pais ? pais.paisId : undefined;
		this.clientObj.codigoPais = pais ? pais.codigoSii : undefined;
		this.clientObj.emisorId = this.clientToEdit ? this.clientToEdit.emisorId : this.emisorId;
		this.clientObj.codigoInterno = this.clientForm.controls.codigoInterno.value;
		if (this.clientToEdit) {
			this.clientObj.clienteInternacionalId = this.clientToEdit.clienteInternacionalId;
		}
	}

	setClientDataToForm(receivedClient: ClienteInternacional) {
		this.clientForm.patchValue(receivedClient);
		let currentCountry = this.paisesSource.find((country) => country.paisId == receivedClient.paisId);
		this.clientForm.controls.pais.patchValue(currentCountry);
		if (this.detailMode) {
			this.clientForm.controls.pais.disable();
		}
	}
}
